import { isSmallScreen, prefersReducedMotion } from './motion';

export const initTilt = (selector = '.tilt-card'): void => {
  if (isSmallScreen() || prefersReducedMotion()) return;

  const elements = document.querySelectorAll<HTMLElement>(selector);

  elements.forEach(el => {
    // Ensure the card has overflow:hidden for the spotlight pseudo-element to be clipped
    el.style.overflow = 'hidden';

    el.addEventListener('mousemove', e => {
      const rect = el.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const centerX = rect.width / 2;
      const centerY = rect.height / 2;

      const rotateX = ((y - centerY) / centerY) * -10;
      const rotateY = ((x - centerX) / centerX) * 10;

      el.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.04, 1.04, 1.04)`;
      el.style.transition = 'transform 0.08s ease';

      // Iridescent spotlight: update CSS custom properties
      const xPct = (x / rect.width) * 100;
      const yPct = (y / rect.height) * 100;
      el.style.setProperty('--mx', `${xPct}%`);
      el.style.setProperty('--my', `${yPct}%`);
      el.style.setProperty('--spotlight-opacity', '1');
    });

    el.addEventListener('mouseleave', () => {
      el.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)';
      el.style.transition = 'transform 0.55s ease';
      el.style.setProperty('--spotlight-opacity', '0');
    });
  });
};
